export default __webpack_public_path__ + "dim-d4bd38.json";